import { initialState } from "src/modals/embedded-integration-v2/constants/initialState"

export const initialPurchaseSimpleLinkDynamicFieldState = {
    linkTitle: { ...initialState },
    linkUrl: { ...initialState },
}
